import { getBlob, type StoredBlob } from '../offline/db.js';

export interface Preview {
  localId: string;
  url: string;
}

/** Подмена для тестов: доступ к хранилищу и созданию ссылок — внешние зависимости. */
export interface PreviewDeps {
  load: (localId: string) => Promise<StoredBlob | undefined>;
  makeUrl: (blob: Blob) => string;
}

const defaultDeps: PreviewDeps = {
  load: getBlob,
  makeUrl: (blob) => URL.createObjectURL(blob),
};

/**
 * Превью строятся ИЗ списка снимков пункта, а не копятся по мере съёмки.
 *
 * Накопительный список переживал переход к следующему пункту: водитель видел
 * снимок предыдущего узла рядом с требованием «фото обязательно». Обратный
 * случай так же важен — возврат «Назад» и восстановление черновика после
 * разряженного телефона обязаны показать то, что уже снято.
 *
 * Пропавший блоб не роняет экран: его просто нет в списке.
 */
export async function previewsFor(
  photoIds: readonly string[],
  deps: PreviewDeps = defaultDeps,
): Promise<Preview[]> {
  const previews: Preview[] = [];
  for (const localId of photoIds) {
    const stored = await deps.load(localId);
    if (stored === undefined) continue;
    previews.push({
      localId,
      url: deps.makeUrl(new Blob([stored.bytes], { type: stored.mime })),
    });
  }
  return previews;
}
